export class SearchRepository{    
    SearchDocument(SearchRequest) {
        throw new Error('SearchDocument method not implemented');
      }
      
}